// What can replace a lift (Kenny, 2026-11-02: "muscles around the muscle groups we are hitting").
// Pure, no DB. Three lists: same muscle and same kind of lift (the book's rule, p.320), same muscle
// but a different kind, and lifts for the muscles working next to it. Nothing here changes a plan.

export const NEARBY = {
  chest: ['shoulders', 'triceps'],
  shoulders: ['chest', 'triceps', 'back'],
  triceps: ['chest', 'shoulders'],
  back: ['biceps', 'shoulders', 'hamstrings'],
  biceps: ['back'],
  quads: ['glutes', 'hamstrings', 'calves'],
  hamstrings: ['glutes', 'back', 'quads'],
  glutes: ['hamstrings', 'quads'],
  calves: ['quads', 'hamstrings'],
  abs: ['back'],
};

export function buildSwapOptions(lift, library) {
  const mg = lift?.muscle_group;
  const others = (library || []).filter((x) => x.id !== lift?.id);
  const isSameKind = (x) => !!x.is_primary === !!lift?.is_primary;
  const isSameArea = (x) => (mg && x.muscle_group === mg) || (lift?.swap_group && x.swap_group === lift.swap_group);
  const byCloseness = (a, b) => (b.swap_group === lift?.swap_group) - (a.swap_group === lift?.swap_group) || a.name.localeCompare(b.name);
  const area = others.filter(isSameArea).sort(byCloseness);
  const around = NEARBY[mg] || [];
  const nearby = others.filter((x) => !isSameArea(x) && around.includes(x.muscle_group))
    .sort((a, b) => around.indexOf(a.muscle_group) - around.indexOf(b.muscle_group) || a.name.localeCompare(b.name));
  return { same: area.filter(isSameKind), different: area.filter((x) => !isSameKind(x)), nearby };
}
